(function ($) {
    
    function arrowClicks(){
        $('.nav-menu a').on('click',function(e) {
            
            var href = $(this).attr('href');
            
            if (href === '#' && $(this).parent().hasClass('menu-item-has-children')){
                e.preventDefault();
                $( this ).siblings('.sub-menu').addClass('active');
                $( this ).closest('.menu-item').addClass('open');
                $( this ).parent().siblings('.menu-item').addClass('hidden');
            }
        });
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $( this ).next().addClass('active');
            $( this ).closest('.menu-item').addClass('open');
            $( this ).parent().siblings('.menu-item').addClass('hidden');
            $( this ).closest('.sub-menu').addClass('parent');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this ).data('sidr-menu');
            $( '#' + menuCloseId ).removeClass('active');
            $( '#' + menuCloseId ).parents('.sub-menu').removeClass('parent');
            $( this ).closest('.menu-item').removeClass('open');
            
            $( this ).parent().closest('.menu-item').siblings('.menu-item').removeClass('hidden');
        });
    }
    
    function stickyNav(){
        var $scrollTop = $(window).scrollTop();
        
		if ($scrollTop > 50) {
			$('#masthead .site-header-main').addClass('sticky');
		} else {
			$('#masthead .site-header-main').removeClass('sticky');
		}
	};

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
            anchorPlacement: 'top-bottom'
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'), {
            disableParallax: /iPhone|iPod|Android/,
        });

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });

        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<div class="sidr__header">';
                sidrHtml += '<div class="sidr__logo">' + $('.site-header-title').html() + '</div>';
                sidrHtml += '<button class="sidr__close"><span class="screen-reader-text">Close</span></button>';
                sidrHtml += '</div>';
                
                sidrHtml += '<div class="sidr__inner">';
                
                sidrHtml += '<div class="sidr__mainnav">';
                sidrHtml += '<ul class="nav-menu">';
                    
                if($('.main-navigation').length){
                    sidrHtml += $('.main-navigation .nav-menu').html();
                }
                
                sidrHtml += '</ul>';
                sidrHtml += '</div>';
                
                if($('.site-header .buttons').length){
                    sidrHtml += '<div class="sidr__buttons">' + $('.site-header .buttons').html() + '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                var headerHeight = $("#masthead").height(),
                    windowHeight = $(window).height();
                
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
                
                $('.sidr__inner').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id'),
                        parentLink = $(this).prevAll('a').attr('href'),
                        parentText = $(this).prevAll('a').html();
                    
                    $(this).attr('id','sidr-' + menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-' + menuId + '">' + parentText + '</li>');
                });
            },
            onOpenEnd: function(){
                arrowClicks();
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
                $('.site-header').removeClass('sticky');
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
            }
        });

        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
            $('sidr__menu-back').unbind();
            stickyNav();
        });
        
        stickyNav();
        
        
        $( '.js-video-popup' ).magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
        $( '.js-modal-popup' ).magnificPopup({
            type: 'inline',
            preloader: false
        });

	});
    
    $(document).on("mousedown touchstart",function(event){
        if($(event.target).closest('#sitesearch--toggle').length && $(event.target).is('#sitesearch--toggle')) {
            $('#sitesearch').addClass('active');
            $.sidr('close','sidr');
        }
        if($(event.target).closest('#sitesearch--close').length && $(event.target).is('#sitesearch--close')) {
            $('#sitesearch').removeClass('active');
        }
        if($(event.target).closest('#sitesearch.active').length && $(event.target).is('#sitesearch.active')) {
            $("#sitesearch").removeClass('active');
        } 
    });
    
    //on resize
//    $(window).on('resize', function(){
//        AOS.refresh();
//    });
//    $("#page").on('scroll', function () {
//        AOS.refresh();
//    });
    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
    });

    
    $(window).scroll(function() {
        stickyNav();
    });
    
})(jQuery);